/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetVehicleEventsParams,
  VehicleAuditEventPageDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType } from '../../../../custom-instance';




/**
 * The vehicle's audit trail, newest first. Every attempt is listed, successful or not: `outcome` says which it was. BattAdmin only.
 * @summary getVehicleEvents
 */
export const getVehicleEvents = (
    vehicleId: string,
    params?: GetVehicleEventsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleAuditEventPageDto>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/events`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetVehicleEventsQueryKey = (vehicleId?: string,
    params?: GetVehicleEventsParams,) => {
    return [`/fleet/vehicle/v1/vehicles/${vehicleId}/events`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVehicleEventsQueryOptions = <TData = Awaited<ReturnType<typeof getVehicleEvents>>, TError = ErrorType<null | null | null | null | null>>(vehicleId: string,
    params?: GetVehicleEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleEvents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehicleEventsQueryKey(vehicleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleEvents>>> = ({ signal }) => getVehicleEvents(vehicleId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehicleEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehicleEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicleEvents>>>
export type GetVehicleEventsQueryError = ErrorType<null | null | null | null | null>


export function useGetVehicleEvents<TData = Awaited<ReturnType<typeof getVehicleEvents>>, TError = ErrorType<null | null | null | null | null>>(
 vehicleId: string,
    params: undefined |  GetVehicleEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleEvents>>,
          TError,
          Awaited<ReturnType<typeof getVehicleEvents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleEvents<TData = Awaited<ReturnType<typeof getVehicleEvents>>, TError = ErrorType<null | null | null | null | null>>(
 vehicleId: string,
    params?: GetVehicleEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleEvents>>,
          TError,
          Awaited<ReturnType<typeof getVehicleEvents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleEvents<TData = Awaited<ReturnType<typeof getVehicleEvents>>, TError = ErrorType<null | null | null | null | null>>(
 vehicleId: string,
    params?: GetVehicleEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getVehicleEvents
 */

export function useGetVehicleEvents<TData = Awaited<ReturnType<typeof getVehicleEvents>>, TError = ErrorType<null | null | null | null | null>>(
 vehicleId: string,
    params?: GetVehicleEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleEvents>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehicleEventsQueryOptions(vehicleId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



